<template>
    <div class="header">
        <v-app-bar class="geodis" color="white" height="80" flat>
            <div class="d-flex align-center">
                <!-- <img class="logo" src="@/assets/geodis/logo_blue.png" /> -->
                <img
                    class="logo"
                    :src="`data:image/png;base64,${this.$store.getters.getClientLogo}`"
                    v-if="
                        this.$store.getters.getClientLogo &&
                        !$route.path.startsWith('/informations') &&
                        !$route.path.startsWith('/informations') &&
                        !$route.path.startsWith('/admin/backoffice')
                    "
                />
                <img v-else class="logo" src="@/assets/geodis/logo.svg" />
                <h1 class="link-home" v-if="!$route.path.startsWith('/OSOL')" v-on:click="$route.path !== '/' && redirectTo('/')">
                    Extranet
                </h1>
                <h1 v-else>Extranet</h1>
            </div>

            <v-spacer></v-spacer>

            <div class="actions">
                <span class="help-account">
                    <Help
                        v-if="
                            (!checkAuthorization.trackandtrace_anon &&
                                this.$store.state.user.informations &&
                                this.$store.state.user.informations.firstname) ||
                            this.$route.path.includes('/OSOL')
                        "
                    />
                </span>
            </div>
            <div v-if="!checkAuthorization.trackandtrace_anon">
                <div class="actions" v-if="this.$store.state.user.informations && this.$store.state.user.informations.firstname">
                    <v-menu offset-y v-if="getLanguages() && getLanguages().length > 1 && !$vuetify.breakpoint.smAndDown">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark v-bind="attrs" v-on="on" elevation="0" color="#3200E6">
                                {{ mapLangTitles[selectedLang].substring(0, 2) }}
                                <v-icon right dark> mdi-chevron-down </v-icon>
                            </v-btn>
                        </template>
                        <v-list class="language-selection">
                            <v-list-item
                                v-for="lang in languages"
                                :key="lang"
                                v-bind:class="{ selectedLanguage: selectedLang === lang }"
                            >
                                <v-list-item-title @click="setLocale(lang)">{{ mapLangTitles[lang] }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn elevation="0" color="white" class="user-menu" v-bind="attrs" v-on="on">
                                <span class="initials">
                                    {{ $store.state.user.informations.firstname.split('')[0] }}
                                    {{ $store.state.user.informations.lastname.split('')[0] }}
                                </span>
                                <span>{{ $store.state.user.informations.firstname }}</span>
                                <v-icon small>mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list class="user-menu-list">
                            <v-list-item class="name">
                                <v-list-item-title
                                    >{{ $store.state.user.informations.firstname }}
                                    {{ $store.state.user.informations.lastname }}</v-list-item-title
                                >
                            </v-list-item>
                            <v-list-group
                                :value="false"
                                class="user-menu-list-languages"
                                no-action
                                @click="e => e.stopImmediatePropagation()"
                                prepend-icon="mdi-earth"
                                v-if="getLanguages() && getLanguages().length > 1 && $vuetify.breakpoint.smAndDown"
                            >
                                <template v-slot:activator>
                                    <v-list-item-title>Languages</v-list-item-title>
                                </template>
                                <v-list-item
                                    v-for="lang in getLanguages()"
                                    :key="lang"
                                    :class="{ selectedLanguage: selectedLang === lang }"
                                >
                                    <v-list-item-title @click="setLocale(lang)">{{ mapLangTitles[lang] }}</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                            <v-list-item v-if="this.$store.state.groups.userRoles && this.$store.state.groups.userRoles.admin">
                                <v-list-item-icon>
                                    <v-icon>mdi-home</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-on:click="redirectTo('/admin/backoffice')">{{
                                        $t('backoffice.title')
                                    }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="this.$store.state.groups.userRoles && this.$store.state.groups.userRoles.admin">
                                <v-list-item-icon>
                                    <v-icon>mdi-database-refresh-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-on:click="redirectTo('/admin/migration')">Migration</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="this.$store.state.groups.connected === false">
                                <v-list-item-icon>
                                    <v-icon>mdi-login</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-on:click="redirectTo('/login/sso')">Sign-in</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-else>
                                <v-list-item-icon>
                                    <v-icon>mdi-logout</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-on:click="signOut()">Sign-out</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <div v-else>
                    <v-btn v-on:click="redirectTo('/login/sso')">Sign-in</v-btn>
                </div>
            </div>
        </v-app-bar>
        <v-app-bar class="client" height="50" flat>
            <div class="links d-flex align-center">
                <router-link
                    class="home"
                    :to="
                        this.$store.state.clients && this.$store.state.clients.list && this.$store.state.clients.list.length > 1
                            ? '/'
                            : `/${this.$store.getters.getClientName}`
                    "
                    v-if="
                        !checkAuthorization.trackandtrace_anon &&
                        ((this.$store.state.groups.userRoles &&
                            (this.$store.state.groups.userRoles.admin || this.$store.state.clients.current !== null)) ||
                            $route.path.startsWith('/informations'))
                    "
                >
                    Home
                </router-link>
                <div
                    class="breadcrumb"
                    v-if="
                        this.$store.state.groups.userRoles &&
                        this.$store.state.groups.userRoles.admin &&
                        this.$store.state.clients.current !== null &&
                        !$route.path.startsWith('/informations') &&
                        !$route.path.startsWith('/admin')
                    "
                >
                    <v-icon x-small color="white">fas fa-chevron-right</v-icon>
                    <router-link :to="`/${this.$store.getters.getClientName}`">
                        <span class="page">{{ this.$store.getters.getClientName }}</span>
                    </router-link>
                </div>
                <div class="breadcrumb" v-if="$route.path.startsWith('/informations')">
                    <v-icon x-small color="white">fas fa-chevron-right</v-icon>
                    <router-link :to="$route.path">
                        <span class="page">{{
                            $route.path.split('/')[2] === 'rgpd' ? $t('footer.RGPD.title') : $t('footer.legalMentions')
                        }}</span>
                    </router-link>
                </div>
                <div class="breadcrumb" v-if="$route.path.startsWith('/admin/backoffice')">
                    <v-icon x-small color="white">fas fa-chevron-right</v-icon>
                    <router-link :to="$route.path">
                        <span class="page">{{ $t('backoffice.title') }}</span>
                    </router-link>
                </div>
                <div class="breadcrumb" v-for="(route, index) in breadcrumbs" :key="index">
                    <span v-if="route && !$route.path.startsWith('/admin') && !$route.path.startsWith('/informations')">
                        <v-icon x-small color="white">fas fa-chevron-right</v-icon>
                        <router-link :to="`/${$store.getters.getClientName}${route.url}`">
                            <span class="page">{{ route.breadcrumb_label }}</span>
                        </router-link>
                    </span>
                </div>
            </div>
        </v-app-bar>
    </div>
</template>

<script>
import { api } from '@/utils/api';
import Help from '@/components/Help.vue';

import { mapState, mapMutations } from 'vuex';
import * as R from 'ramda';

const mapLangTitles = {
    en: 'English',
    fr: 'Francais',
    es: 'Español',
    de: 'Deutsch',
    it: 'Italiano',
    pt: 'português',
    pl: 'polonês'
};

export default {
    components: {
        Help
    },
    data() {
        return {
            window: window,
            mapLangTitles
        };
    },
    mounted: function () {
        this.updateLocale();
    },
    methods: {
        ...mapMutations('languages', ['selectLang', 'setLanguages']),
        ...mapState(['getCurrentClientId']),
        getLanguages() {
            if (this.$route.path.startsWith('/informations/') || this.$route.path.startsWith('/admin/')) {
                return ['de', 'en', 'es', 'fr', 'pl', 'pt'];
            } else if (this.$route.path == '/') {
                return [];
            }
            return this.languages;
        },
        async setLocale(locale) {
            this.selectLang(locale);
            await api.setLang(locale, this.$i18n, this.$vuetify);
            this.updateLocale(locale);
        },
        updateLocale(locale) {
            const clientId = this.$store.state.clients.current;
            if (clientId) {
                const language = JSON.parse(localStorage.getItem('language') || '{}');
                if (locale) {
                    language[clientId] = locale;
                }
                localStorage.setItem('language', JSON.stringify(language));
                if (window.OneTrust) {
                    window.OneTrust.changeLanguage(language[clientId]);
                }
            }
        },
        signOut: async function () {
            const res = await api.get(['admin', 'logout'], null, { withCredentials: true });
            window.location.href = res;
        },
        redirectTo: function (path) {
            this.$router.push(path);
        }
    },
    computed: {
        ...mapState('languages', ['languages', 'selectedLang']),
        checkAuthorization() {
            return {
                trackandtrace_anon: this.$store.state.groups.userRoles?.trackandtrace?.anon
            };
        },
        breadcrumbs() {
            if (this.$route.path.startsWith('/OSOL') || this.$route.path.includes('/OSOL/')) {
                return [];
            }
            const updateTitle = (...steps) => {
                document.title = [...steps.reverse(), 'PORTAL CL'].filter(i => !!i).join(' | ');
            };
            const client = this.$store.getters._getClient;
            const clientId = client?.id || null;
            this.updateLocale();

            const { list, current, service, dashboards, portletId, dashboardId, currentIframeServiceNumber } =
                this.$store.state.clients;
            const services = R.clone(this.$store.state.clients.services);

            if (!list || !current || !service || !client) {
                updateTitle(client?.name);
                return [];
            }

            // patch BI et BPM header ( generic method used for all services) using translations collection
            Object.keys(services).map(key => {
                // verify label in translations collection: translations.
                const label = `services.default.${clientId}.${key}.breadcrumbLabel`;
                if (this.$te(label) && services[key]) {
                    services[key]['breadcrumb_label'] = this.$t(label);
                }
            });

            let serviceName = this.$store.getters.getServiceName || client.services[service].name;
            if (serviceName?.requires_auth) serviceName = 'docs';
            const browerPaths = window.location.pathname.split('/').filter(path => !!path);

            // iframe list
            const iframeServices = ['BI', 'BPM'];

            let array = services[serviceName].routes.filter((route, index) => {
                if (serviceName.includes('IFRAME') && currentIframeServiceNumber) {
                    if (route.url === '/IFRAME') {
                        route.url = route.url + '/' + currentIframeServiceNumber;
                        let iframeService = `${serviceName}${currentIframeServiceNumber}`;
                        let translation = `services.${clientId}.${iframeService}.breadcrumbLabel`;
                        let iframeLabel = (this.$te(translation) && this.$t(translation)) || null;
                        route.breadcrumb_label = iframeLabel || services[serviceName].breadcrumb_label || serviceName;
                        return true;
                    } else {
                        return false;
                    }
                }
                if (!route.name) return false;
                if (index === 0) {
                    route.breadcrumb_label = serviceName;
                    let translation;
                    let id = `services.${serviceName}.${client.id}.title`;
                    let translate = this.$t(id);
                    if (translate !== id) translation = translate;
                    else {
                        id = `services.${serviceName}.default.title`;
                        translate = this.$t(id);
                        translation = translate !== id && translate;
                    }
                    route.breadcrumb_label = translation || services[serviceName].breadcrumb_label || serviceName;
                }
                const routePaths = route.url
                    ?.split('?')[0]
                    .split('/')
                    .filter(path => !!path);
                return routePaths && routePaths.length + 1 <= browerPaths.length;
            });
            if (dashboardId && iframeServices.includes(serviceName) && browerPaths.includes(dashboardId.toString())) {
                array.push({
                    breadcrumb_label: dashboards.find(d => d.id === dashboardId)?.name,
                    url: `${array[array.length - 1].url}/${dashboardId}`
                });
            } else if (serviceName.includes('IFRAME') && dashboardId && browerPaths.includes(dashboardId.toString())) {
                let translation = `IFRAME${currentIframeServiceNumber}.${clientId}.${dashboardId}.title`;
                if (this.$store.getters.getAuthorizedInstances.length > 1) {
                    array.push({
                        breadcrumb_label: this.$te(translation)
                            ? this.$t(translation)
                            : `IFRAME${currentIframeServiceNumber}: Instance ${dashboardId}`,
                        url: `${array[array.length - 1].url}/${dashboardId}`
                    });
                }
            } else if (portletId && serviceName === 'genericsearch' && browerPaths.includes(portletId.toString())) {
                const key = `genericSearch.${client.id}.${portletId}.name`;
                array.push({
                    breadcrumb_label: this.$te(key) ? this.$t(key) : this.$t('genericSearch.default.name'),
                    url: `${array[array.length - 1].url}/${portletId}`
                });
            }
            updateTitle(client.name, ...array.map(i => i.breadcrumb_label || i.name));

            // return list
            return array;
        }
    }
};
</script>

<style lang="scss">
@import '@/scss/_colors.scss';

.help-account {
    margin-right: 8px;
}
header.geodis {
    .link-home {
        cursor: pointer;
    }
    .logo {
        height: 50px;
    }
    h1 {
        font-weight: 400;
        margin-left: 20px;
        font-size: 16px;
        margin-bottom: 4px;
        color: $primary;
    }
    .user-menu {
        color: #f7f7f7;
        > * {
            color: $primary;
        }
        white-space: nowrap;
        height: auto !important;
        padding: 10px !important;
        text-transform: none;
        &:hover {
            background-color: none;
        }
        .initials {
            border-radius: 50%;
            background-color: $primary;
            color: #f7f7f7;
            text-transform: uppercase;
            font-weight: 700;
            font-size: 16px;
            letter-spacing: -1px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 42px;
            height: 42px;
            margin-right: 10px;
            margin-left: 10px;
        }
        .v-icon {
            margin-left: 5px;
        }
    }
}

.user-menu-list {
    .v-list-item__title {
        color: $primary;
        font-weight: 700;
    }
    .name {
        font-family: 'IBM Plex Mono', monospace;
        border-bottom: 1px solid #d5d5d5;
        .v-list-item__title {
            font-weight: 400;
        }
    }
    i {
        color: $primary !important;
    }
    .v-list-item__title {
        cursor: pointer;
    }
}

.language-selection {
    .v-list-item__title {
        cursor: pointer;
    }
}

header.client {
    background-color: $primary !important;
    .links {
        font-size: 0.8em;
        .home {
            i {
                margin-right: 5px;
                margin-top: -3px;
            }
            &.router-link-exact-active {
                font-weight: 700;
            }
        }
        a {
            text-decoration: none;
            color: #fff;
            padding: 0;
        }
        .breadcrumb {
            i {
                margin: 0 10px;
                font-size: 0.6em !important;
            }
            .router-link-exact-active {
                font-weight: 700;
            }
        }
    }
}

.selectedLanguage {
    background-color: #3200e61e;
}
</style>
